import useI18n from "@/hooks/useI18n";
import Link from "@/components/react/Link";
import { css, cx } from "@styled-system/css";
import FreeIcon from "@/assets/common/free.svg?react";
import { Flex, Box } from "@styled-system/jsx";
import { button } from "@styled-system/recipes";

export default function FreeCard({ currency }: { currency: any }) {
  const { t } = useI18n();
  return (
    <Flex
      className={css({
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "flex-end",
        height: "100%",
        borderRadius: "1.5rem",
        border: "1px solid",
        borderColor: "lowBorder",
        overflow: "hidden"
      })}
    >
      <Flex w="100%" justifyContent="center" bg="lowBorder">
        <h6 className={css({ my: "6px" })}>{t("free")}</h6>
      </Flex>
      <Flex
        className={css({
          width: "100%",
          height: "100%",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          rowGap: "20px",
          p: "1.5rem"
        })}
      >
        <FreeIcon className={css({ mt: "18px" })} />
        <Box textAlign="center">
          <p className={css({ textStyle: "overline", mb: "6px", color: "lowEmphasis" })}>
            {t("freePlan").toUpperCase()}
          </p>
          <h5 className={css({ mb: "18px" })}>
            0 {currency} / {t("lifetime")}
          </h5>
        </Box>
        <Link href="/download">
          <button
            id="download-free"
            className={cx(
              button({ variant: "outlined" }),
              css({
                py: "1.25rem !important",
                fontSize: "1rem !important"
              })
            )}
          >
            {t("header.download")}
          </button>
        </Link>
      </Flex>
    </Flex>
  );
}
